class MainSearch extends SearchForm {
  constructor() {
    super();
    // Only sync storefront queries; Figure Finder option searches are independent.
    this.allSearchInputs = Array.from(document.querySelectorAll('input[type="search"][name="q"]')).filter(
      (input) => input.form,
    );
    this.setupEventListeners();
  }

  setupEventListeners() {
    const allSearchForms = [...new Set(this.allSearchInputs.map((input) => input.form))];
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
